
export default function BCISection() {
  return (
    <section id="bci" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-[#0B1F3B]/5 rounded-full mb-4 sm:mb-6">
              <span className="text-sm font-semibold text-[#0B1F3B]">Servizio Core</span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight text-left">
              Brand Capital Index (BCI)
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1C]/80 mb-4 sm:mb-5 leading-relaxed">
              Il Brand Capital Index è un algoritmo proprietario che misura il valore patrimoniale del brand attraverso l'integrazione di KPI economici, reputazionali e strategici.
            </p>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 mb-5 sm:mb-6 leading-relaxed">
              La metodologia BCI produce uno score numerico difendibile, supportato da documentazione tecnica completa, utilizzabile per capitalizzazione a bilancio, accesso al credito e operazioni straordinarie.
            </p>

            <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-4 sm:p-5 lg:p-6 mb-5 sm:mb-6">
              <h3 className="text-base sm:text-lg font-bold text-[#0B1F3B] mb-4 sm:mb-5">Cosa Misura il BCI</h3>
              <div className="space-y-4 sm:space-y-5">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-[#0B1F3B]">KPI Economici</span>
                    <span className="text-sm font-bold text-[#E879F9]">40%</span>
                  </div>
                  <div className="w-full bg-[#0B1F3B]/10 rounded-full h-2">
                    <div className="bg-[#E879F9] h-2 rounded-full" style={{ width: '40%' }}></div>
                  </div>
                  <p className="text-xs text-[#1C1C1C]/60 mt-2">
                    Fatturato attribuibile, marginalità, crescita storica, proiezioni finanziarie
                  </p>
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-[#0B1F3B]">KPI Reputazionali</span>
                    <span className="text-sm font-bold text-[#E879F9]">35%</span>
                  </div>
                  <div className="w-full bg-[#0B1F3B]/10 rounded-full h-2">
                    <div className="bg-[#E879F9] h-2 rounded-full" style={{ width: '35%' }}></div>
                  </div>
                  <p className="text-xs text-[#1C1C1C]/60 mt-2">
                    Brand awareness, NPS, posizionamento competitivo, fedeltà clienti
                  </p>
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-[#0B1F3B]">KPI Strategici</span>
                    <span className="text-sm font-bold text-[#E879F9]">25%</span>
                  </div>
                  <div className="w-full bg-[#0B1F3B]/10 rounded-full h-2">
                    <div className="bg-[#E879F9] h-2 rounded-full" style={{ width: '25%' }}></div>
                  </div>
                  <p className="text-xs text-[#1C1C1C]/60 mt-2">
                    Protezione legale, estensibilità, governance, potenziale licensing
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B]">Output del Servizio</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <div className="flex items-start gap-3">
                  <i className="ri-file-chart-line text-[#E879F9] text-lg mt-1"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">Report Tecnico BCI</p>
                    <p className="text-xs text-[#1C1C1C]/60">Documento completo con score e analisi</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-dashboard-line text-[#E879F9] text-lg mt-1"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">Dashboard KPI</p>
                    <p className="text-xs text-[#1C1C1C]/60">Monitoraggio metriche in tempo reale</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-line-chart-line text-[#E879F9] text-lg mt-1"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">Analisi Comparativa</p>
                    <p className="text-xs text-[#1C1C1C]/60">Benchmark settoriale e competitivo</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-roadmap-line text-[#E879F9] text-lg mt-1"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">Raccomandazioni</p>
                    <p className="text-xs text-[#1C1C1C]/60">Piano di ottimizzazione del valore</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <div className="w-full h-[400px] sm:h-[500px] lg:h-[650px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/c57ddc7ec877c8bcca13f9fa53b3f26d.jpg"
                  alt="Brand Capital Index Dashboard"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="absolute -bottom-4 -right-4 bg-[#0B1F3B] rounded-lg shadow-xl p-4 sm:p-5 max-w-[200px] sm:max-w-xs">
              <p className="text-xs text-white/80 mb-1">Esempio BCI Score</p>
              <p className="text-2xl sm:text-3xl font-bold text-[#E879F9] mb-1">8.4/10</p>
              <p className="text-xs text-white/60">Valore stimato: €1.8M</p>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 lg:mt-12 bg-[#0B1F3B] rounded-lg p-6 sm:p-8 text-center">
          <h3 className="font-serif text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3">
            Scarica un Esempio di Report BCI
          </h3>
          <p className="text-sm sm:text-base text-white/80 mb-5 sm:mb-6 max-w-2xl mx-auto">
            Visualizza un caso reale di valutazione Brand Capital Index per comprendere la metodologia e l'output del servizio
          </p>
          <button className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-[#E879F9] text-white rounded-md text-sm sm:text-base font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-download-line mr-2"></i>
            Scarica Esempio PDF
          </button>
        </div>
      </div>
    </section>
  );
}
